'use strict';
import angular from 'angular';
import ExistingAddressesController from './existing-address.controller';
import angularFilter from 'angular-filter';
import paging from '../paging';
export default angular.module('directives.existingAddresses', [
    angularFilter, paging
])
    .component('existingAddresses', {
    template: require('./existing-addresses.html'),
    controller: ExistingAddressesController,
    controllerAs: 'pop',
    bindings: {
        loggedInUser: '<',
        selectedAddress: '<'
    }
})
    .name;
//# sourceMappingURL=index.js.map